export const wrapTooltipContent = (content, additionClass) => {
  return `<div style="white-space: normal; word-break: break-word; max-width: 300px; min-width: 100px;" class="text-[15px] px-4 py-2 flex justify-center items-center ${additionClass}">${content}</div>`;
};
